import { render } from "./TranslationMenu.vue?vue&type=template&id=bcceb5d0&scoped=true"
import script from "./TranslationMenu.vue?vue&type=script&lang=js"
export * from "./TranslationMenu.vue?vue&type=script&lang=js"

import "./TranslationMenu.vue?vue&type=style&index=0&id=bcceb5d0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcceb5d0"]])

export default __exports__